import type {Comment, Thread} from '@github-ui/diff-lines/conversation-types'

export function getComments(thread: Thread): Comment[] {
  return thread.commentsData?.comments ?? []
}

/** The first comment in the thread. */
export function getInitialComment(thread: Thread): Comment | undefined {
  return getComments(thread)[0]
}

/** The most recent comment in the thread (the initial comment when there are no replies). */
export function getLatestComment(thread: Thread): Comment | undefined {
  const comments = getComments(thread)
  return comments[comments.length - 1]
}

/** The most recent comment, but only when it is a reply (i.e. not the initial comment). */
export function getLatestReply(thread: Thread): Comment | undefined {
  const comments = getComments(thread)
  return comments.length > 1 ? comments[comments.length - 1] : undefined
}

const COMMENT_SNIPPET_LENGTH = 100

/**
 * Gets a snippet of the comment text, truncated to the maximum length.
 * While `text-overflow: ellipsis` will handle dynamic truncation, we still want to limit the length of the rendered
 * string for accessibility and performance.
 */
export function getCommentSnippet(comment: Comment): string {
  const normalized = comment.body.replace(/\s+/g, ' ').trim()
  const chars = Array.from(normalized)
  return chars.length > COMMENT_SNIPPET_LENGTH ? `${chars.slice(0, COMMENT_SNIPPET_LENGTH).join('')}…` : normalized
}
